const items = [
  "Landing Page",
  "E-Commerce",
  "Prenotazioni Online",
  "Siti Vetrina",
  "Su Misura",
  "affige.it",
  "MPX Digital",
];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <section className="relative -rotate-1 border-y border-white/8 bg-zinc-950/60 py-6 overflow-hidden" data-testid="marquee-section">
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span
              className={`font-syne text-3xl sm:text-4xl font-extrabold tracking-tight ${
                i % 2 === 0 ? "text-zinc-100" : "text-outline"
              }`}
            >
              {item}
            </span>
            <span className="text-cyan-400 text-xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
};
